var topNav = require("../topNav");
var searchBox = require("../searchBox");
var myAccount = require("../myAccount");
var loginDropdown = require("../loginDropdown");
var utils = require("../../shared/utils");

var actions = {
    closeItems: () => {
        components.topNav.actions.close();
        components.search.actions.close();
        components.myAccount.actions.close(); 
    }
};

var components = {}
var create = function () {
    components.topNav = topNav.create("#menu-wrap");
    components.search = searchBox.create();
    //Render MyAccount Links (Logged-in ONLY)
    if (utils.isAuthenticated()) {
        components.myAccount = myAccount.create('.natp-login-container');
    } else {
        components.myAccount = loginDropdown.create('.natp-login-container')
    }
    bindEvents();
}

var bindEvents = function () {
    $("body").on("click", (e) => {
        if (!$(e.target).hasClass("header-dropdown") && !$(e.target).closest(".header-dropdown").length && !$(e.target).hasClass("natp-login-dropdown") && !$(e.target).closest(".natp-login-dropdown").length) {
            actions.closeItems();
        }
    });

    // TODO: implement this
    //  $('#natp-login-dropdownBtn').on("click", (e) => {
    //      //Check to see if the dropdown is open. If not, wait and check again.
    //      setTimeout(function() {
    //          if ($("#natp-login-dropdownContainer").hasClass("open"))
    //         {	
    //             var $userInputBox = $(".natp-login-dropdown-menu").find(".natpUserNameTextBox").find("input:text");
    //             $userInputBox.focus();
    //         }
    //      }, 100);
    // });


    $(document).on("header-section-toggle", (e, component) => {
        var isOpen = component.$container.hasClass("open");
        console.log(isOpen);
        actions.closeItems();
        if (!isOpen) 
            component.actions.open();
    })
}
module.exports = { create }


// WEBPACK FOOTER //
// ./src/scripts/components/header/index.js